import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from "components/CustomButtons/Button.js";
import history from '../../../../../../history';
import { withStyles } from '@material-ui/core/styles';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { isEmpty } from "lodash";
import Simplert from 'react-simplert';
import Check from "@material-ui/icons/Check";
import { InsertOrder, isReturnPalletsRequired, isInterestedInTiles } from "../../../../../store/actions";

import { withRouter } from "react-router-dom";
import $ from 'jquery';
import { compose } from "redux";

import {
    Checkbox

} from "@material-ui/core";

import {
    blackColor,
    infoColor,

    hexToRgb,
} from "../../../../../../assets/jss/material-kit-pro-react.js";


const useStyles = theme => ({
    left: {
        float: "left!important",
        display: "block",
    },
    right: {
        margin: "0",
        float: "right!important",
        display: "block",
    },
    closebuttonPopUp: {
        backgroundColor: "#FF2E2E", border: "none", color: "white", padding: "15px 28px", textAlign: "center",
        textDecoration: "none", display: "inline-block", margin: "13px 2px", cursor: "pointer"
    },
    confirmbuttonPopUp: {
        backgroundColor: "#7ea11d", border: "none", color: "white", padding: "15px 28px", textAlign: "center",
        textDecoration: "none", display: "inline-block", margin: "13px 2px", cursor: "pointer"
    },
    textarea: {
        paddingBottom: "20px",
        paddingTop: "10px",
    },
    checked: {
        color: infoColor[0] + "!important",
    },
    checkedIcon: {
        width: "25px",
        height: "25px",
        border: "0.5px solid rgba(" + hexToRgb(blackColor) + ", 0.54)",
        borderRadius: "3px",
    },
    uncheckedIcon: {
        width: "25px",
        height: "25px",
        padding: "9px",
        border: "0.5px solid rgba(" + hexToRgb(blackColor) + ", .54)",
        borderRadius: "3px",
    },
    checkRoot: {
        padding: "14px",
        "&:hover": {
            backgroundColor:
                "rgba(" + hexToRgb(infoColor[0]) + ", 0.14) !important",
        },
    }
});


class StageTwoNextBackButtons extends Component {

    state = {
        hasPallets: false,
        tileInterest: false,
        readTerms: false,

        //pop up message
        showAlert: false,
        typeAlert: '',
        titleAlert: '',
        messageAlert: '',
        disable: false
    }

    disbaleElements = (e) => {
        this.setState({ disable: e }, () => {
        });
    }

    displayMessage = (type, title, message) => {
        this.setState({
            showAlert: true,
            typeAlert: type,
            titleAlert: title,
            messageAlert: message,

        }, () => {
            window.scrollTo(0, 0)
        });
    }

    handlePopUpMessage = () => {
        this.setState({ showAlert: false });
    }


    onActiveToggle = (e) => {

        this.setState({ readTerms: e.target.value }, () => {

        });

    }

    onActivePalletsToggle = (e) => {

        this.setState({ hasPallets: e.target.value }, () => {
            this.props.isReturnPalletsRequired(e.target.value);
        });

    }

    onTileInterestToggle = (e) => {

        this.setState({ tileInterest: e.target.value }, () => {
            this.props.isInterestedInTiles(e.target.value);
        });

    }

    SummarySubmit = () => {

        if (this.props.orderSummaryResult.total_Price_Inc_VAT === 0 || this.props.orderSummaryResult.total_Price_EX_Vat === 0 || this.props.orderSummaryResult.original_Total_price === 0) {

            // TO NOTE- IF THIS OCCURE ENSURE THAT DELIVERY SITE CHOSEN IS FOR CADEBY
            this.displayMessage("error", "No Price Found", "Please contact office as no prices could be found for this order");
            return;

        }

        if (this.state.readTerms === false) {

            this.displayMessage("error", "Terms and Conditions", "Please confirm you have read terms and conditions before submitting");
            return;
        }


        if (this.props.user.realex_Enabled) {
            this.props.history.push("/OrderPayment")
        }
        else {
            this.disbaleElements(true);
            this.insertOrder();
        }
    }


    insertOrder = async () => {

        try {

            const { orderSummaryResult, specialInstructions, reqDelDate, cusOrderNumber, branchId, selectedDeliverySiteId, totalWeight, nmbsReference, returnPalllets, tileInterest, quoteId } = this.props

            await this.props.InsertOrder(orderSummaryResult, specialInstructions, reqDelDate, cusOrderNumber, branchId, selectedDeliverySiteId, totalWeight, nmbsReference, false, returnPalllets, tileInterest, quoteId);


            if (!isEmpty(this.props.fpmccann_OrderNumber)) {
                this.props.history.push("/OrderConfirmation") // order saved 
            }
            else {
                this.props.history.push("/error-page") // error didnt save order
            }

        } catch (e) {

        }
    }




    render() {


        const { classes } = this.props;



        return (
            <div>
                <GridContainer>

                    <Simplert
                        style={{
                            width: '250px;'
                        }}
                        showSimplert={this.state.showAlert}
                        type={this.state.typeAlert}
                        title={this.state.titleAlert}
                        message={this.state.messageAlert}
                        onClose={() => this.handlePopUpMessage()}
                        disableOverlayClick={true}
                        useConfirmBtn={false}
                        customCloseBtnClass={classes.closebuttonPopUp}
                    />


                    <GridItem xs={12} sm={12} md={12} style={{ paddingTop: "0px" }}>


                        <h5 className={classes.textarea} style={{ textAlign: "justify" }}>
                            <b> {"Delivery Dates"}</b> are dependent on stock levels and FP McCann confirmation.

                           {/* < br/>
                            Do you have any pallets to return? <b>(min. of 50?) {" "}</b>
                            <Checkbox

                                checkedIcon={
                                    <Check className={classes.checkedIcon} />
                                }
                                icon={
                                    <Check className={classes.uncheckedIcon} />
                                }
                                classes={{
                                    checked: classes.checked,
                                    root: classes.checkRoot,
                                }}
                                checked={this.state.hasPallets ? this.state.hasPallets : false}
                                onChange={(e) => {
                                    this.onActivePalletsToggle({
                                        target: {
                                            name: e.target.name,
                                            value: e.target.checked,
                                        },
                                    });
                                }}
                            /> */}

                            < br />
                            <b>Should you be interested in receiving a Roof Tile sample please tick here {" "}</b>
                            <Checkbox

                                checkedIcon={
                                    <Check className={classes.checkedIcon} />
                                }
                                icon={
                                    <Check className={classes.uncheckedIcon} />
                                }
                                classes={{
                                    checked: classes.checked,
                                    root: classes.checkRoot,
                                }}
                                checked={this.state.tileInterest ? this.state.tileInterest : false}
                                onChange={(e) => {
                                    this.onTileInterestToggle({
                                        target: {
                                            name: e.target.name,
                                            value: e.target.checked,
                                        },
                                    });
                                }}
                            />


                            <br />
                            Have you read and agreed to our <a href="https://fpmccann.co.uk/conditions-of-purchase/"
                                style={{ color: 'red' }} target="_blank">terms {'&'} conditions</a> of sale?
                            <Checkbox

                                checkedIcon={
                                    <Check className={classes.checkedIcon} />
                                }
                                icon={
                                    <Check className={classes.uncheckedIcon} />
                                }
                                classes={{
                                    checked: classes.checked,
                                    root: classes.checkRoot,
                                }}
                                checked={this.state.readTerms ? this.state.readTerms : false}
                                onChange={(e) => {
                                    this.onActiveToggle({
                                        target: {
                                            name: e.target.name,
                                            value: e.target.checked,
                                        },
                                    });
                                }}
                            />

                        </h5>


                        <div className={classes.left}>


                            <Button
                                style={{
                                    borderRadius: 2,
                                    padding: "16px 20px",
                                    fontSize: "15px"
                                }}
                                color="danger"
                                size="lg"
                                target="_blank"
                                onClick={() => history.goBack()}
                            >
                                <i className="far fa-window-close"></i>
                                &nbsp; Back
                            </Button>
                        </div>


                        <div className={classes.right}>
                            <Button
                                style={{
                                    borderRadius: 2,
                                    padding: "16px 20px",
                                    fontSize: "15px"
                                }}
                                color="success"
                                size="lg"
                                target="_blank"
                                onClick={this.SummarySubmit}
                                disabled={this.state.disable}
                            >
                                <i className="far fa-hand-point-right"></i>
                                &nbsp; Confirm Order
                            </Button>
                        </div>




                    </GridItem>

                </GridContainer>
            </div>
        )
    }
}

const mapStateToProps = state => {

    return {

        // order data
        nmbsReference: state.orderReducer.nmbsReference,
        user: state.userReducer.user,
        selectedDeliverySiteId: state.orderReducer.selectedDeliverySiteId,
        reqDelDate: state.orderReducer.reqDelDate,
        totalWeight: state.orderReducer.totalWeight,
        branchId: state.orderReducer.selectedBranchId,
        orderSummaryResult: state.orderReducer.orderSummaryResult,
        specialInstructions: state.orderReducer.specialInstructions,
        cusOrderNumber: state.orderReducer.cusOrderNumber,
        fpmccann_OrderNumber: state.orderReducer.fpmccann_OrderNumber,
        returnPalllets: state.orderReducer.palletsRequired,
        tileInterest: state.orderReducer.tileInterest,
        quoteId: state.orderReducer.selectedQuoteId

    };
};



export default compose(withRouter, connect(mapStateToProps, { InsertOrder, isReturnPalletsRequired, isInterestedInTiles }))(withStyles(useStyles)(StageTwoNextBackButtons));